export default __webpack_public_path__ + "static/media/drone1.0e4a4d8e.jpg";